<template>
	<div>
		<v-navigation-drawer
			v-if="isTriggers && this.$route.name != 'Login'"
			:value="value"
			@input="$emit('input', $event)"
			app
			right
		>
			<action-list
				:entity="entity"
				:noSearch="noSearch"
				:title="title"
				:data="data"
			></action-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
	import actionList from "../actions/actionList";
	export default {
		name: "drawer-action",
		props: ["value", "entity", "noSearch", "title", "persistent", "data"],
		components: {
			actionList,
		},

		data() {
			return {
				actions: [],
				actionsGroup: [],
				panel: [],
				search: "",
				drawer: false,
				loading: false,
				itemSelected: {},
				isTriggers: false,
			};
		},

		watch: {
			value() {
				this.drawer = this.value;
			},
			search() {
				this.actionsGroup = this.setupActions();
			},
		},

		methods: {
			sortAlph(a, b) {
				if (a < b) return -1;
				else if (a > b) return +1;
				else return 0;
			},
			clickAction() {},
			createGroups() {
				let groups = [];
				groups.push(null);
				groups.push("");
				this.actions.forEach((a) => {
					if (groups.indexOf(a.group) < 0) groups.push(a.group);
				});

				let sort = groups.sort(this.sortAlph);

				return sort;
			},
			setupActions() {
				let actionsGroup = [];
				let groups = this.createGroups();

				groups.forEach((g) =>
					actionsGroup.push({
						group: g,
						actions: [],
					})
				);
				actionsGroup.forEach((ag) => {
					if (!this.search || this.search.lenght == 0) {
						ag.actions = this.actions
							.filter((a) => a.group == ag.group)
							.sort(this.sortAlph);
					} else {
						ag.actions = this.actions
							.filter(
								(a) =>
									a.group == ag.group &&
									a.description
										.toLowerCase()
										.indexOf(this.search.toLowerCase()) >= 0
							)
							.sort(this.sortAlph);
					}
				});
				actionsGroup.forEach((ag, i) => this.panel.push(i));
				return actionsGroup;
			},
			async getActions() {
				this.$http
					.get("action/separate")
					.then((res) => {
						if (res && res.success) {
							this.actions = res.data;
							this.actionsGroup = this.setupActions();
						}
					})
					.catch(() => {});
			},
			getValues() {
				let values = [];
				this.itemSelected.fields.forEach((item, index) => {
					let component = this.$refs[index.toString()][0];
					let fieldValue = component.getValue();
					values.push(fieldValue);
				});
				return values;
			},
			clearFields() {
				this.itemSelected.fields.forEach((item, index) => {
					let component = this.$refs[index.toString()][0];
					component.clear();
				});
			},
			fieldsValidate() {
				let valid = true;
				this.itemSelected.fields.forEach((item, index) => {
					let component = this.$refs[index.toString()][0];
					let isValid = component.validate();

					if (!isValid) valid = false;
				});
				return valid;
			},
			closeDialog() {
				this.$refs.dialogFields.open(false);
				this.clearFields();
			},
			confirm() {
				if (this.itemSelected.fields && this.itemSelected.fields.length > 0) {
					let fieldsValidate = this.fieldsValidate();
					if (!fieldsValidate) return;
					this.getValues();
					this.closeDialog();
				}
			},
			clickItem(item) {
				this.itemSelected = item;
				if (item.fields && item.fields.length > 0)
					this.$refs.dialogFields.open();
			},
		},
		async mounted() {
			this.drawer = this.value;
			this.isTriggers = await this.$auth.isTriggers();
			await this.getActions();

		},
		created() {
			this.$root.$on("click-content", () => {
				if (this.persistent == null) {
					this.$emit("input", false);
				}
			});
		},
	};
</script>
